import React, { useCallback } from 'react';
import { SaveButton, Toolbar } from 'react-admin';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { useHistory, useLocation } from 'react-router-dom';

const styles = {
  button: {
    marginRight: '8px'
  },
  toolbar: {
    backgroundColor: 'transparent',
    paddingLeft: '16px'
  }
};

const CreateToolbar = ({
  classes,
  allowNavigationOnSave,
  _submitting,
  disabled,
  ...rest
}) => {
  const history = useHistory();
  const location = useLocation();

  const handleClickCancel = useCallback(() => {
    history.push(location.pathname.split('/create')[0]);
  }, [history, location.pathname]);

  return (
    <Toolbar {...rest} className={classes.toolbar}>
      <SaveButton
        label="Create"
        icon={<></>}
        className={classes.button}
        onClick={allowNavigationOnSave}
        disabled={disabled}
      />
      <>
        {' '}
        {/** to prevent property forwarding */}
        <Button
          variant="outlined"
          onClick={handleClickCancel}
          color="primary"
          id="back-button"
        >
          Back
        </Button>
      </>
    </Toolbar>
  );
};

export default withStyles(styles)(CreateToolbar);
